import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

import {planPropTypes} from '../../../utils/propTypes';

import PlanFee from './PlanFee';
import PlanPricing from './PlanPricing';
import PlanConditions from './PlanConditions';
import PlanPrefix from './PlanPrefix';

function Header(props) {
  const isCurrentPlan = props.currentPlan?.externalId === props.plan.externalId;
  return (
    <div className="row">
      <div className="col-12 d-flex flex-column align-items-center">
        <PlanPrefix
          plan={props.plan}
          isCurrentPlan={isCurrentPlan}
        />
        <strong className="information-primary uppercase font-size-xxl text-center">
          <Translate
            value={`subscriptions.plans.title.${props.plan.externalId}`}
          />
        </strong>
        <span className="my-4">
          <PlanConditions plan={props.plan}/>
        </span>
        <PlanPricing plan={props.plan}/>

        {!isCurrentPlan &&
            <button
              type="button"
              data-id="submit"
              className="large primary mt-4"
              onClick={() => props.onPlanSelection(props.plan)}
            >
              <strong><Translate value="subscriptions.plans.subscribe"/></strong>
            </button>
        }
        <PlanFee plan={props.plan}/>
      </div>
    </div>
  );
}

Header.propTypes = {
  plan: planPropTypes().isRequired,
  onPlanSelection: PropTypes.func.isRequired,
  currentPlan: planPropTypes()
};

export default Header;
